import config_name from '@/components/crud/config_name.js';
import {parse_filters,same_array} from '@/functions/general.js';
export default {
  mixins:[config_name],
  props:{
    on_change:{default:()=>()=>{}},
    item_key:{},/* es el valor q se mostrara de la lista */
    label:{},
    return_object:{},
    value:{},
    prepend_icon:{},
    append_icon:{},
    value_key:{},/* del objeto seleccionado de la lista[value_key] sera el valor retornado */
    ex_filters:{default:()=>{return{}}}
  },
  data() {
    return {
      search: null,
    };
  },
  computed: {
    navegations(){ return this.$store.getters.navegations },
    navegation(){ return this.navegations[this.config_name_all_computed] || {} },
  },
  watch: {
    'value'(v,v_old){ 
      if (this.multiple) {
        if (v === v_old) return;// caso null
        else if (Array.isArray(v) && Array.isArray(v_old) && same_array(v,v_old)) return;
      }
      else if (v === v_old) return;
      this.set_model()
    },
    'myRequestStatus.rq'(v){
      // si no es quien busco
      if (this.myRequestStatuslast_key_filterd && this.k_f !== this.myRequestStatuslast_key_filterd) {
          this.myRequestStatus.rq
            .then(r => this.then_get_rows(r));
      }
    },
  },
  created() {
    this.set_model(this.values(this.myRequestStatus_filter));
  }, // created
  methods: {
    multiple_parse_val(v){ return [v||[]].join(',')},
    searchM(v,v_old){
      /* v,v_old comparar si son iguales , return */
      const val = this.multiple? this.multiple_parse_val(v):v;
      if (this.myRequestStatus_filter[this.k_f] === val) return;//si se esta usando como valor el mismo rqstatus, se gatillara 2 veces al cargar || cuando se intente buscar los mismo
      if (this.filter_rq_type.includes('<')) this.items = [];
      this.resetRqStatus();
      this.myRequestStatus.status = 2;
      const filter = {};
      /* agregar un prop que indique que se reinician los filtros al ocultarse/cerrarse, para que no de problemas cuando abra un dialogo con otro item */
      filter[this.k_f] = this.search;
      this.pre_get(filter,this.k_f);
			this.getRows();
    },
    pre_get(filter={},last_key_filterd){
      this.navegation.page = 1;
      Object.assign(this.myRequestStatus_filter,filter, {page:1});
      this.myRequestStatus.last_key_filterd = last_key_filterd;
    },
    change(){  this.upd() || this.on_change(this.myRequestStatus.rq) },
    /* se filtran valores q no deberian tomar los filtros usados por este codigo */
    values(v){return !!Object.keys(v)/* this.filter_by */.filter(k => ![null,undefined,'',false].includes(v[k])).length },
    get_rq (ex_f,only_cache) {
      if (this.requestStatus_status === 2) return Promise.resolve([]);
      if (this.reset_on_value_change) this.resetRqStatus();
      if (only_cache) return this.myRequestStatus.rq ? this.myRequestStatus.rq.then(r => this.then_get_rows(r)): Promise.resolve([]);
      return this.reset_on_value_change
        ? this.getRows(ex_f)
        : (
          this.myRequestStatus.rq
          ? this.myRequestStatus.rq.then(r => this.then_get_rows(r))
          : this.getRows(ex_f)
        )
    },

    resetRqStatus(){
      this.myRequestStatus.status = false;
      this.myRequestStatus.ticking = false;
      /* this.myRequestStatus.rq = null; */
    },
    getRows(ex_f={}){
      const a = {a:true};
      const b = {a:false};
      Object.assign(a,b);
      const fls = Object.assign({},this.myRequestStatus_filter,{...this.ex_filters},ex_f);
      const filters = parse_filters(fls);
      const {page_size} = this.navegation||{};
      if (page_size) filters.page_size = page_size;
      return this.requests.gets[this.name_all_computed](filters)
        .then(r => this.then_get_rows(r));
    },
  },
};
